import {
    IMPORT_FILE_MODE_IMPORTMODE,
    KEY_FILE_DIR,
    KEY_IS_ENABLE_SYNC,
    KEY_MACHINEID,
    KEY_PROJECT_THUMB_INDEX,
    LINK_INFO_TYPE_ELEMENT,
    LINK_INFO_TYPE_FILE,
    LINK_INFO_TYPE_HIGHLIGHT,
    LINK_INFO_TYPE_LIBRARY,
    LINK_INFO_TYPE_NOTE,
    LINK_INFO_TYPE_PAGE,
    LINK_INFO_TYPE_PDF,
    LINK_INFO_TYPE_PDF_HIGHLIGHT,
    LINK_INFO_TYPE_PROJECT,
    LINK_INFO_TYPE_VIDEO_HIGHLIGHT, SEARCH_WIDTH,
    SYS_CONFIG_KEY_THEME, THEME_LIGHT
} from "@/Const";
import {PROJECT_ID} from "@/views/Draw/DrawIndex";
import i18next, {t} from "i18next";
import {getCardTitle0} from "@/Utility0";
import {getCardById, getLibraryPdfCount, getLibraryVideoCount, updateCard} from "@model/card";
import {isMacOs} from "react-device-detect";
import {
    checkIfAbsolute,
    decodeDeeplink,
    firstLetterUpper,
    formatDate,
    generateRandomPageKey,
    generateUUID2,
    getFileName,
    getFileNameWithoutExt,
    getIntValue,
    getItem,
    getLocalFilePath,
    getPdfImageThumb,
    getVideoImageThumb,
    hasDesktopBaseLicense,
    hasLicense, isAnnoElement,
    isAudio, isCardBlockDeeplink,
    isDarkMode,
    isDeepLink, isFileElement, isFileVideoElement,
    isImage, isInDraw, isLiveVideoElement,
    isNoteElement,
    isPdf, isPdfFileElement, isSupportVideoType,
    isVideo
} from "@/utils";
import {ipcInvoke, ipcSend} from "@/common/ipc";
import {isZh} from "@/language";
import {getNoteById} from "@model/note";
import global from "@/global";
import {dbGetHighlight, dbGetYoutubeHightlightCount} from "@model/highlight";
import {APP_WEB, isWebApp} from "@/electron_interactive";
import {getShareDataUrl} from "@/api/Aws";
import {updateFavorFolder} from "@model/FavorFolder";
import {
    getCardElementIcon,
    getFrameElementIcon, getImageElementIcon,
    getMindmapElementIcon,
    getStickNoteElementIcon,
    IconFavorFolder,
    IconFolder
} from "@/Icon";
import {isTextElement} from "../@excalidraw/packages/excalidraw/element";
import {
    isFrameElement,
    isImageElement,
    isMindmapElement,
    isProjectLinkElement,
    isShapeElement, isStickyNotesElement
} from "../@excalidraw/packages/excalidraw/element/typeChecks";
import { message } from "antd";

export async function deepLinkToLinkInfo(deeplink:any){
    var newLinkInfo = {};
    if (deeplink.type == 'library'){
        const library = await window.methodGetNoteById(deeplink.id);
        //打开..
        if (deeplink.childType == 'card'){
            newLinkInfo.type = LINK_INFO_TYPE_NOTE;
            newLinkInfo.id = deeplink.id;
        }else if (deeplink.childType == 'pdf'){
            newLinkInfo.type = LINK_INFO_TYPE_PDF;
            newLinkInfo.id = deeplink.id;
            newLinkInfo.fileName = library.fileName;
        }else{
            newLinkInfo.type = LINK_INFO_TYPE_FILE;
            newLinkInfo.id = deeplink.id;
            newLinkInfo.fileName = library.fileName;
        }
    }else if (deeplink.type == 'project'){
        //表明是一个元素...
        //是否是当前项目的
        const isCurrentProject = PROJECT_ID == deeplink.id;
        if (deeplink.elementId){
            newLinkInfo.type = LINK_INFO_TYPE_ELEMENT;
            newLinkInfo.id = deeplink.id;
            newLinkInfo.pageId = deeplink.childId;
            newLinkInfo.elementId = deeplink.elementId;
            newLinkInfo.nodeId = deeplink.nodeId;
        }else{
            newLinkInfo.type = LINK_INFO_TYPE_PAGE;
            newLinkInfo.id = deeplink.id;
            newLinkInfo.pageId = deeplink.childId;
        }
        newLinkInfo.isCurrentProject = isCurrentProject;
    }
    return newLinkInfo;
}

/**
 * 库类型中的图标...跟select下拉保持一致.
 * @param szType
 */
export function getLibraryTypeImage(szType:string){
    let szImgName = '';
    if (szType == 'image'){
        szImgName = 'library_type_image'
    }else if (szType == 'card' || szType == 'note'){
        szImgName = 'library_type_card';
    }else if (szType == 'pdf'){
        szImgName = 'library_type_pdf';
    }else if (szType == 'audio'){
        szImgName = 'library_type_audio';
    }else if (szType == 'video'){
        szImgName = 'library_type_video';
    }else if (isSupportVideoType(szType) || szType == 'liveVideo'){
        szImgName = "library_type_online_video";
    }else if (szType == 'project'){
        szImgName = "library_type_project";
    }
    else if (szType == 'file'){
        szImgName = 'library_type_file';
    }else if (szType == 'videoNote' || szType == 'videoAnno' || szType == 'audioAnno'){
        szImgName = 'library_type_anno'
    }else if (szType == 'pdfAnno'){
        szImgName = "library_type_anno"
    }else if (szType == 'cardAnno'){
        szImgName = "library_type_anno";
    }else if (szType == 'webLink'){
        szImgName = "library_type_weblink";
    }else if (szType == 'journal'){
        szImgName = "library_type_journal";
    }
    else{
        szImgName = 'library_type_file';
    }

    return szImgName + '.svg';
}

export function getDeeplinkImage(szType:string){
    return getImageNameFromdeepLinkType(szType);
}

export function getImageNameFromdeepLinkType(szType:string){
    let szImgName = '';
    if (szType == 'image'){
        szImgName = 'deeplink_image'
    }else if (szType == 'text'){
        szImgName = 'deeplink_text';
    }else if (szType == 'freedraw' || szType == 'highlighter'){
        szImgName = 'deeplink_freedraw'
    }else if (szType == 'frame'){
        szImgName = 'deeplink_frame'
    }else if (szType == 'mindmap'){
        szImgName = 'deeplink_mindmap'
    }else if (szType == 'embed'){
        szImgName = 'tool_embed'
    }else if (szType == 'rectangle' ||
        szType == 'roundedRectangle' ||
        szType == 'ellipse' ||
        szType == 'triangle' ||
        szType == 'diamond' ||
        szType == 'bubble' ||
        szType == 'parallelogram' ||
        szType == 'pentagram' ||
        szType == 'thickArrow'){
        szImgName = 'deeplink_shape';
    }else if (szType == 'card' || szType == 'note'){
        szImgName = 'deeplink_card.svg';
    }else if (szType == 'pdf'){
        szImgName = 'deeplink_pdf';
    }else if (szType == 'audio'){
        szImgName = 'deeplink_audio';
    }else if (szType == 'video' || szType == 'bilibili' || szType == 'youtube'){
        szImgName = 'deeplink_video';
    }else if (szType == 'file'){
        szImgName = 'deeplink_file';
    }else if (szType == 'cardBlock'){
        //card内部的一个链接
        szImgName = 'deeplink_card_block';
    }else if (szType == 'videoNote' || szType == 'videoAnno' || szType == 'audioAnno'){
        szImgName = 'deeplink_highlight'
    }else if (szType == 'pdfAnno'){
        szImgName = "deeplink_highlight"
    }else if (szType == 'cardAnno'){
        szImgName = "deeplink_highlight";//"deeplink_card_anno"
    }else if (szType == 'webLink'){
        szImgName = "library_type_weblink";
    }else if (szType == 'journal'){
        szImgName = "deeplink_journal";
    }
    else{
        szImgName = 'deeplink_file';
    }
    if (!szType || szType == 'project' || szType == 'board'){
        szImgName = 'deeplink_project'
    }

    return szImgName;
}

/**
 * 获取card的标题
 */
export function getCardTitle(item:any){
    return getCardTitle0(item);
}

export function getCardBlock(html:any,szId:any){
    const div = document.createElement('div');
    div.innerHTML = html;
    for (let i=0;i<div.childElementCount;i++){
        const p = div.childNodes[i];
        if (p.dataset.id == szId){
            return p.innerText;
        }
    }
    return '';
}

export function getAllDeeplinks(szHtml){
    let pattern = /<deeplink(.*?)<\/deeplink>/g;
    let results = szHtml.match(pattern);
    const arrayDeeplinks = [];
    if (results) {
        const parser = new DOMParser();
        for (let i = 0; i < results.length; i++) {
            //获取标题和链接
            const szStr = results[i];
            const xmlDoc = parser.parseFromString(szStr, 'text/xml');
            const deeplinkTag = xmlDoc.getElementsByTagName('deeplink')[0];
            if (deeplinkTag) {
                const szName = deeplinkTag.getAttribute('text');
                const szHref: any = deeplinkTag.getAttribute('href');
                arrayDeeplinks.push(szHref);
            }
        }
    }
    return arrayDeeplinks;
}

/**
 * 超过免费视频限制
 */
export const beyondFreeVideoLimit = async ()=>{
    const nCount:any = await getLibraryVideoCount();
    return (nCount >= 3);
    // return getCurrentVideoElementCount() >= 3;
}

/**
 * 超过免费视频限制
 */
export const beyondFreePdfLimit = async ()=>{
    const nCount:any = await getLibraryPdfCount();
    return (nCount >= 3);
    // return getCurrentVideoElementCount() >= 3;
}

export function isMac(){
    return isMacOs;
}

/**
 * 暂停所有视频播放
 */
export function pauseAllVideo(currentVideo:any){
    // const arrayVideos = document.getElementsByTagName('video');
    // for (let i=0;i<arrayVideos.length;i++){
    //     const video = arrayVideos[i];
    //     if (video != currentVideo){
    //         video.pause();
    //     }
    // }
}

export function pauseAllAudio(currentAudio:any){
    // const arrayVideos = document.getElementsByTagName('audio');
    // for (let i=0;i<arrayVideos.length;i++){
    //     const video = arrayVideos[i];
    //     if (video != currentAudio){
    //         video.pause();
    //     }
    // }
}

//获取主题配色
export function getTheme(){
    return localStorage.getItem(SYS_CONFIG_KEY_THEME) || THEME_LIGHT;
}

/**
 * 创建deeplink的视图
 * @param cardId
 * @param text
 * @param szContent
 * @param szImage
 */
export function createDeeplinkView(cardId,text,szContent,szImage,szType){
    //不要传id了，使用自动生成的....
    return `<deeplink href="${text}" text="${szContent + ' '}" image="${szImage}" type='${szType}' isFirst="true"></deeplink>`
}

/**
 * 是全局的右键
 */
export const isGlobalRightSlider = ()=>{
    return window.location.href.includes('/library') || window.location.href.includes('/journal') || window.location.href.includes('/card') || window.location.href.includes('/highlight') || window.location.href.includes('project');
}

/**
 * 2级的导航菜单
 * @param szType
 * @param szLevelTitle
 */
export function createBreadcrumb(szType:string | 'library'|'journal'|'highlight',szLevelTitle2:any){
    let szMainTitle = '';
    if (szType == 'library'){
        szMainTitle = i18next.t('Library');
    }else if (szType == 'journal'){
        szMainTitle = i18next.t('Journal');
    }else if (szType == 'highlight'){
        szMainTitle = i18next.t('Highlights');
    }
    return [
        {
            type:szType,
            title:szMainTitle
        },
        {
            type:szType,
            title: szLevelTitle2
        }
    ]
}

/**
 * 搜索框动态宽度
 */
export function getSearchWidth(){
    // return (286.0/1920.0 * document.body.clientWidth) + 'px';
    return `${SEARCH_WIDTH}px`;
}

export const beyondFreeYoutubeHightlightLimit = async ()=>{
    const nCount = await dbGetYoutubeHightlightCount();
    return nCount > 3;
}

/**
 * 是否有旋转的图标.
 * @param element
 */
export const hasElementRotate = (element:any)=>{
   return isTextElement(element) || isShapeElement(element) || isImageElement(element) || isStickyNotesElement(element);
}

export const openUrlOrLocalPath = (szUrl)=>{
    if (checkIfAbsolute(szUrl) || isSupportLink(szUrl)){
        //本地路径...
        ipcInvoke('open-url-withwhen',decodeURIComponent(szUrl));
    }else{
        if (!szUrl?.includes('.')){
            message.error(t('Invalid link'));
        }else{
            if (!szUrl?.startsWith('http')) {
                szUrl = 'https://' + szUrl;
            }
            window.open(szUrl, '_blank');
        }
    }
}

/**
 * 插入附件到库
 * @param szImportMode
 * @param szFilePath
 */
export async function insertFileToLibrary(szImportMode:any,file:any){
    const selectedFile = file;
    let szFileName = selectedFile.path;
    let isAbsolutePath = true;
    if (szImportMode == IMPORT_FILE_MODE_IMPORTMODE){
        const res = await ipcInvoke('copy-file',{filePath:selectedFile.path});
        szFileName = res;
        isAbsolutePath = false;
    }

    let szImgBase64:any = '';
    let szType = 'file';
    if (isPdf(selectedFile.path)){
        szImgBase64 = await getPdfImageThumb(getLocalFilePath(szFileName,isAbsolutePath));
        szType = 'pdf'
        let nPdfCount = await beyondFreePdfLimit();
        if (!hasLicense() && !hasDesktopBaseLicense() && nPdfCount){
            window.showMessageBox(t("Upgrade required"), t("NeedUpgradeToImportPDF"), t("Cancel"), t("Learn more"), null, () => {
                if (isZh()) {
                    ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
                }else {
                    ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                }
            })
            return null;
        }
    }else if (isVideo(selectedFile.path)){
        szImgBase64 = await getVideoImageThumb(getLocalFilePath(szFileName,isAbsolutePath));
        szType = 'video'
        let nVideoCount = await beyondFreeVideoLimit();
        if (!hasLicense() && !hasDesktopBaseLicense() && nVideoCount){
            window.showMessageBox(t("Upgrade required"), t("NeedUpgradeToImportVideoMore"), t("Cancel"), t("Learn more"), null, () => {
                if (isZh()) {
                    ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
                }else {
                    ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                }
            })
            return null;
        }

    }else if (isImage(selectedFile.path)){
        szType = 'image'
    }else if (isAudio(selectedFile.path)){
        szType = 'audio'
    }

    const id = generateUUID2();
    //缩略图保存为文件
    let szSrc = '';
    if (szImgBase64){
        const szFileName = id + ".png";
        await ipcInvoke('write-base64-image',{fileName:szFileName,imgBase64:szImgBase64});
        szSrc = getScheme()+szFileName;
    }

    const item = {
        id:id,
        name:getFileName(szFileName),
        fileName:szFileName,
        type:szType,
        thumbImage:szSrc,
        isAbsolutePath:isAbsolutePath,
        createTime:Date.now()
    }
    await updateCard(item);
    return item;
}


/**
 * 添加图片到库....
 * @param szType
 * @param szFileName
 */
export const addImageToLibaray = async (szType:string,szFileName:string)=>{
    const item:any = {
        id:generateUUID2(),
        name:getFileNameWithoutExt(szFileName),
        fileName:szFileName,
        type:szType,
        createTime:Date.now(),
        tags:global.g_currentTag?[global.g_currentTag]:[]
    }
    let szThumbImage:any = '';
    if (szType == 'video'){
        szThumbImage = await getVideoImageThumb(getLocalFilePath(szFileName,false));
    }else if (szType == 'pdf'){
        szThumbImage = await getPdfImageThumb(getLocalFilePath(szFileName,false));
    }
    if (szThumbImage){
        //保存到本地
        const szLocalFileName = item.id + '.png';
        await ipcInvoke('write-base64-image',{fileName:szLocalFileName,imgBase64:szThumbImage});

        item.thumbImage = getScheme()+szLocalFileName;
    }

    await updateCard(item);
    return item;
}

/**
 * 插入deeplink链接
 * @param text
 */
export const insertDeeplinkToCard = (text:any,editorView:any,nPos:any)=>{
    const linkInfo = decodeDeeplink(text);
    // editor?.commands.insertContent(`<a href='${text}' target="_self">${linkInfo.id}</a>`);
    let szContent = '';
    let isOk = '';
    global.g_isRefreshLibraryInfoLink = true;
    if (linkInfo.type == LINK_INFO_TYPE_PROJECT) {
        getNoteById(linkInfo.id).then(async (res: any) => {
            szContent = res.name;
            const jsonDoc = JSON.parse(res.doc);
            let szBoardName = '';
            let mElement: any;
            for (let i = 0; i < jsonDoc.canvas.length; i++) {
                const board = jsonDoc.canvas[i];
                if (board.key == linkInfo.childId) {
                    szBoardName = board.title;
                    for (let j = 0; j < board.drawJson.elements.length; j++) {
                        const element = board.drawJson.elements[j];
                        if (element.id == linkInfo.elementId) {
                            mElement = element;
                            break;
                        }
                    }
                }
            }
            if (linkInfo.elementId) {
                //取元素名称
                if (linkInfo.elementType == 'text') {
                    //取这个文本的内容
                    szContent += '-->' + mElement?.text
                }else if (linkInfo.elementType == 'card'){
                    const card = await getCardById(linkInfo.libraryId,false);
                    szContent += '-->' + card?.name || firstLetterUpper(linkInfo.elementType);
                }
                else {
                    szContent += '-->' + firstLetterUpper(linkInfo.elementType);
                }

            } else if (linkInfo.childId) {
                //子board
                szContent += '-->' + szBoardName;
            }
            let szImage = getImageNameFromdeepLinkType(linkInfo.elementType, mElement?.customData?.generationData?.fileName) + '.png';
            // editorView.dom.editor.commands.insertContent(`<div style="display: flex;flex-direction: column"><img style='width:32px;height: 32px' src='${imgPathPerfix()+szImage}'/><a href='${text}' target="_blank">${szContent}</a></div>`,{
            //   parseOptions: {
            //     preserveWhitespace: false,
            //   },
            // });
            if (nPos){
                editorView.dom.editor.commands.insertContentAt(nPos,createDeeplinkView(res.id,text,szContent,szImage), {
                    parseOptions: {
                        preserveWhitespace: false,
                    },
                });
            }else{
                editorView.dom.editor.commands.insertContent(createDeeplinkView(res.id,text,szContent,szImage), {
                    parseOptions: {
                        preserveWhitespace: false,
                    },
                });
            }

        })
    } else if (linkInfo.type == LINK_INFO_TYPE_LIBRARY) {
        //library里面又拖进来 pdf高亮？？？？？？？？？？？
        if (linkInfo.childType == LINK_INFO_TYPE_PDF_HIGHLIGHT){
            //pdf注记
            getCardById(linkInfo.id)?.then(async (res)=>{
                const pdfLib:any = await getCardById(res.id);
                szContent = pdfLib.name + '-->'+res.text;
                let szImage = getImageNameFromdeepLinkType('pdfAnno',null)+'.png';
                //' '如果content 不加这个，大纯数字会被转成科学计数法，怎么搞字符串都不能变回来。。。SHIT一样的JS
                if (nPos){
                    editorView.dom.editor.commands.insertContentAt(nPos,createDeeplinkView(res.id,text,szContent,szImage), {
                        parseOptions: {
                            preserveWhitespace: false,
                        },
                    });
                }else{
                    editorView.dom.editor.commands.insertContent(createDeeplinkView(res.id,text,szContent,szImage), {
                        parseOptions: {
                            preserveWhitespace: false,
                        },
                    });
                }
            })
        }else if (linkInfo.childType == LINK_INFO_TYPE_VIDEO_HIGHLIGHT){
            //pdf注记
            getCardById(linkInfo.id)?.then(async (res)=>{
                const pdfLib:any = await getCardById(res.id);
                szContent = pdfLib.name + '-->'+res.text;
                let szImage = getImageNameFromdeepLinkType('videoNote',null)+'.png';
                //' '如果content 不加这个，大纯数字会被转成科学计数法，怎么搞字符串都不能变回来。。。SHIT一样的JS
                if (nPos){
                    editorView.dom.editor.commands.insertContentAt(nPos,createDeeplinkView(res.id,text,szContent,szImage), {
                        parseOptions: {
                            preserveWhitespace: false,
                        },
                    });
                }else{
                    editorView.dom.editor.commands.insertContent(createDeeplinkView(res.id,text,szContent,szImage), {
                        parseOptions: {
                            preserveWhitespace: false,
                        },
                    });
                }
            })
        }
        else{
            getCardById(linkInfo.id, true)?.then(res => {
                szContent = res.name;
                let szType = res.type;
                if (res.type == 'card') {
                    szContent = getCardTitle(res);
                    let szBlockContent = getCardBlock(res.doc,linkInfo.childId);
                    if (linkInfo.childType == 'card' && linkInfo.childId){
                        //card 中的一个link.....
                        szType = 'cardBlock';
                        if (linkInfo.elementType == 'paragraph'){
                            szContent += '-->' + szBlockContent;
                        }else if (linkInfo.elementType == 'latexBlock'){
                            szContent += '-->' + t('Latex');
                        }else if (linkInfo.elementType == 'codeBlock'){
                            szContent += '-->' + t('CodeBlock');
                        }else if (linkInfo.elementType == 'deeplink'){
                            szContent += '-->'+t("Deeplink");
                        }else if (linkInfo.elementType == 'image'){
                            szContent += '-->'+t("Image");
                        }else if (linkInfo.elementType == 'table'){
                            szContent += '-->'+t("Table");
                        }else{
                            szContent += '-->' + szBlockContent;
                        }
                    }
                }
                let szImage = getImageNameFromdeepLinkType(szType, null) + '.png';
                //' '如果content 不加这个，大纯数字会被转成科学计数法，怎么搞字符串都不能变回来。。。SHIT一样的JS
                if (nPos){
                    editorView.dom.editor.commands.insertContentAt(nPos,createDeeplinkView(res.id,text,szContent,szImage), {
                        parseOptions: {
                            preserveWhitespace: false,
                        },
                    });
                }else{
                    editorView.dom.editor.commands.insertContent(createDeeplinkView(res.id,text,szContent,szImage), {
                        parseOptions: {
                            preserveWhitespace: false,
                        },
                    });
                }
            })
        }

    }else if (linkInfo.type == LINK_INFO_TYPE_HIGHLIGHT){
        dbGetHighlight(linkInfo.id).then(res=>{
            const videoNote = res.data.find(p=>p.id == linkInfo.childId);
            if (videoNote){
                let szImage = getImageNameFromdeepLinkType('videoNote',null)+'.png';
                getCardById(linkInfo.id,false).then((library:any)=>{
                    let szTitle = videoNote.title;
                    if (!szTitle){
                        szTitle = videoNote.content;
                    }
                    let szContent = library.name + `(${formatDate(videoNote.time,'mm:ss')})` + '-->'+(szTitle);
                    //' '如果content 不加这个，大纯数字会被转成科学计数法，怎么搞字符串都不能变回来。。。SHIT一样的JS
                    if (nPos){
                        editorView.dom.editor.commands.insertContentAt(nPos,createDeeplinkView(res.id,text,szContent,szImage), {
                            parseOptions: {
                                preserveWhitespace: false,
                            },
                        });
                    }else{
                        editorView.dom.editor.commands.insertContent(createDeeplinkView(res.id,text,szContent,szImage), {
                            parseOptions: {
                                preserveWhitespace: false,
                            },
                        });
                    }
                })

            }
        })
    }
}


/**
 * 插入复制的链接
 * @param text
 * @param editor
 */
export function insertCopyLinkToCard(text:string,editor:any){
    // [第一条条目标题 ](zotero://select/items/0BFGC5ACZ)
    var reg = new RegExp(/\[.*\]\(zotero:\/\/.*\)$/);
    if (text.match(reg)){
        reg = new RegExp(/\[.*\]/);
        const arrayTxt:any = text.match(reg);
        if (arrayTxt.length > 0){
            const txt = arrayTxt[0].replace('[','').replace(']','');
            const szLink = text.replace(arrayTxt[0],'').replace('(','').replace(')','');
            editor.commands.insertContent(`<a href='${szLink}' target="_self">${txt}</a>`);
            return true;
        }
    }else if (isSupportLink(text)){
        editor.commands.insertContent(`<a href='${text}' target="_self">${text}</a>`);
        return true;
    }
    return false;
}

/**
 * 支持本地打开的链接....
 * @param szText
 */
export function isSupportLink(szText:any){
    return szText.startsWith("obsidian://") || szText.startsWith("zotero://") || szText.startsWith('quicker:') || szText.startsWith('https://onedrive.live') || szText.startsWith('brain://') || szText.startsWith('heptabase://') || isCardBlockDeeplink(szText);
}

/**
 * 是否开启了自动云盘的同步，
 * 2个条件
 * 开启了，并且文件夹路径不是默认的.
 */
export function isAutoEnableSync(){
    return localStorage.getItem(KEY_IS_ENABLE_SYNC)=='true' && global.g_defaultStorePath != localStorage.getItem(KEY_FILE_DIR);
}


export const getVideoPath = (el)=>{
    if(APP_WEB){
        return (getShareDataUrl()+global.g_projId +"/notesfile/")+el.customData?.generationData.fileName;
    }
    if (isWebApp()){
        return el.customData?.generationData.fileName;
    }

    return getLocalFilePath(el.customData?.generationData?.fileName,el.customData?.generationData?.isAbsolutePath)
}

/**
 * 获取收藏的菜单
 */
export const getFavorChildrenMenu = (isFavirated:any,callback:any)=>{
    let arrayMenus = null;
    if (!isFavirated && global.g_arrayFavorFolders.length > 0){
        arrayMenus = [];
        for (let i=0;i<global.g_arrayFavorFolders.length;i++){
            const item = global.g_arrayFavorFolders[i];
            arrayMenus.push(getItem(item.name,item.id,<IconFavorFolder/>,undefined,undefined,(info:any)=>{
                //收藏并且添加到文件夹下。。。
                // info.domEvent.stopPropagation();
                info.domEvent.nativeEvent.stopPropagation();
                callback(info.key)
            }))
        }
    }

    return arrayMenus;
}

export const updateFavorToFolder = (key,data)=>{
    //把这个data插入到文件夹下...
    return new Promise(async (resolve) => {
        const favorFolder = global.g_arrayFavorFolders.find(p=>p.id == key);
        if (favorFolder){
            if (!favorFolder.children){
                favorFolder.children = []
            }
            favorFolder.children.splice(0,0,data);
            await updateFavorFolder(favorFolder);
        }
        resolve('ok')
    })
}

/**
 * 在独立的窗口
 */
export function isInSingleFloatWindow(){
    return window.location.href.includes('floatCard');
}


/**
 * 文件前缀
 */
export function getScheme(){
    return 'localfile://'
}

export function getDrawPath(){
    return '/home/draw'
}

export function getCardPath(){
    return '/home/card'
}


export function getPdfPath(){
    return "/home/pagePdf"
}

export function getTagItemPath(){
    return '/home/tagItemList'
}













